var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "csp-desktop-info-card",
    {
      attrs: {
        cols: 12,
        "form-context": _vm.formContext,
        icon: "inticon-autoclaim_car",
        title: "Fahrzeug",
      },
      on: { change: _vm.reloadVehicleFormData, save: _vm.saveVehicleFormData },
      scopedSlots: _vm._u(
        [
          _vm.formContext.permissions.canCreateRetroactiveChangesNote === true
            ? {
                key: "after-icons",
                fn: function () {
                  return [
                    _c("csp-retroactive-changes-modal", {
                      attrs: { "record-id": _vm.recordId, title: "Fahrzeug" },
                    }),
                  ]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _c(
        "b-tabs",
        { attrs: { align: "center", "no-fade": "" } },
        [
          _c(
            "b-tab",
            {
              attrs: {
                "title-item-class": _vm.formContext.isInEditMode
                  ? ""
                  : "d-none",
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("span", { staticClass: "tab-title" }, [
                        _vm._v("Manuelle Eingabe"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tab-body" },
                [
                  _c("h2", [_vm._v("Grunddaten")]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "3" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "Kennzeichen",
                              property: "licensePlate",
                              type: "text",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "display-value",
                                fn: function () {
                                  return [
                                    _c("csp-license-plate", {
                                      attrs: {
                                        region: _vm.licensePlate.region,
                                        rest: _vm.licensePlate.rest,
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "3" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "Typ",
                              "options-loader": _vm.loadVehicleCategoryOptions,
                              property: "vehicleCategory",
                              required: true,
                              type: "autocomplete",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          dependencies: ["vehicleCategory"],
                          "form-context": _vm.formContext,
                          label: "Hersteller",
                          "options-loader": _vm.loadVehicleManufacturerOptions,
                          property: "vehicleManufacturer",
                          type: "autocomplete",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Modell",
                          property: "model",
                          required: true,
                          type: "text",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Erstzulassungsdatum",
                          property: "registrationDate",
                          type: "datepicker",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Fahrgestellnummer",
                          property: "vin",
                          type: "text",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "HSN",
                          property: "hsn",
                          type: "text",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "TSN",
                          property: "tsn",
                          type: "text",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Kilometerstand",
                          property: "mileage",
                          type: "text",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Leistung (KW)",
                          property: "kw",
                          type: "text",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          dependencies: ["vehicleCategory"],
                          "form-context": _vm.formContext,
                          label: "Treibstoff",
                          "options-loader": _vm.loadVehicleFuelTypeOptions,
                          property: "vehicleFuelType",
                          type: "autocomplete",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Mietwagenklasse",
                          "options-loader": _vm.loadVehicleRentClassOptions,
                          property: "rentClass",
                          type: "autocomplete",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Fahrzeugart Anlieferung",
                          property: "deliveredVehicleType",
                          required: "",
                          type: "autocomplete",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-tab",
            {
              attrs: {
                "title-item-class": _vm.formContext.isInEditMode
                  ? ""
                  : "d-none",
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("span", { staticClass: "tab-title" }, [
                        _vm._v("DAT Suchbaum"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tab-body" },
                [
                  _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                    _vm._v(
                      "\n                    Diese Funktion steht in Kürze wieder zur Verfügung.\n                "
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-tab",
            {
              attrs: {
                "title-item-class": _vm.formContext.isInEditMode
                  ? ""
                  : "d-none",
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("span", { staticClass: "tab-title" }, [
                        _vm._v("VIN Abfrage"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tab-body" },
                [
                  _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                    _vm._v(
                      "\n                    Diese Funktion steht in Kürze wieder zur Verfügung.\n                "
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-tab",
            {
              attrs: {
                "title-item-class": _vm.formContext.isInEditMode
                  ? ""
                  : "d-none",
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("span", { staticClass: "tab-title" }, [
                        _vm._v("HSN/TSN"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tab-body" },
                [
                  _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                    _vm._v(
                      "\n                    Diese Funktion steht in Kürze wieder zur Verfügung.\n                "
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }